/* eslint-disable jsx-a11y/aria-proptypes */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  toAbsoluteUrl,
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../../_metronic/_helpers";
import { useDispatch } from "react-redux";
import { setSelected } from "./invoiceOldSlice";
import { useHistory } from "react-router-dom";
import { formatDate, sizePerPageList, formatCurrency } from "../../../utility";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";

export const SapInvoiceOldTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [tableData, setTableData] = useState(data);

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const showDetail = (column) => {
    dispatch(setSelected(column));
    history.push("/master/sap-invoice-old/detail-data");
  };

  const dateFormatter = (cell) => {
    return <span>{formatDate(cell)}</span>;
  };

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList,
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, column) => (
        <div>
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}
          >
            <a
              className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
              onClick={() => showDetail(column)}
            >
              <span className="svg-icon svg-icon-md svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Write.svg"
                  )}
                />
              </span>
            </a>
          </OverlayTrigger>
        </div>
      ),
    },
    {
      text: "Transaction Date",
      dataField: "transactionDate",
      formatter: dateFormatter,
    },
    { text: "Client Code", dataField: "principalCode" },
    { text: "Client Name", dataField: "principalName" },
    { text: "Invoice Ref Num", dataField: "invoiceNo" },
    { text: "MaterialName", dataField: "itemName" },
    { text: "Plant Name", dataField: "branch" },
    { text: "Customer Name", dataField: "customerName" },
    { text: "Net Sales", dataField: "netSales", formatter: formatCurrency },
    { text: "Net Value", dataField: "salesValue", formatter: formatCurrency },
    { text: "Tax Invoice Number", dataField: "taxInvoice" },
  ];

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={false}
        keyField="approvalDetailId"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        hover
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
    </>
  );
};
